(function() {
  let activeIndex = -1;
  let debounceTimer = null;

  function getElements() {
    const container = document.getElementById("user-autocomplete-container");
    const input = document.getElementById("user_search_input");
    const hiddenInput = document.getElementById("subscription_user_id");
    const dropdown = document.getElementById("user_search_dropdown");
    const clearBtn = document.getElementById("clear_user_btn");
    return { container, input, hiddenInput, dropdown, clearBtn };
  }

  function escapeHtml(str) {
    return (str || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function renderDropdown(users) {
    const { dropdown } = getElements();
    if (!dropdown) return;

    if (!Array.isArray(users) || users.length === 0) {
      dropdown.innerHTML = '<div class="dropdown-item disabled text-muted p-2">No matching users found</div>';
      dropdown.classList.add("show");
      dropdown.style.display = "block";
      return;
    }

    dropdown.innerHTML = users.map((u, index) => `
      <div class="dropdown-item user-option-item text-wrap py-2 border-bottom" data-id="${u.id}" data-text="${escapeHtml(u.email)}" data-index="${index}" style="cursor: pointer;">
        <div class="fw-bold text-dark">${escapeHtml(u.email)}</div>
        ${u.name ? `<div class="small text-muted">${escapeHtml(u.name)}</div>` : ''}
      </div>
    `).join("");

    dropdown.classList.add("show");
    dropdown.style.display = "block";
    activeIndex = -1;
  }

  function selectUser(id, text) {
    const { input, hiddenInput, dropdown, clearBtn } = getElements();
    if (hiddenInput) hiddenInput.value = id;
    if (input) input.value = text;
    if (dropdown) {
      dropdown.classList.remove("show");
      dropdown.style.display = "none";
    }
    if (clearBtn) clearBtn.style.display = "inline-block";
  }

  function clearUser() {
    const { input, hiddenInput, dropdown, clearBtn } = getElements();
    if (hiddenInput) hiddenInput.value = "";
    if (input) {
      input.value = "";
      input.focus();
    }
    if (dropdown) {
      dropdown.classList.remove("show");
      dropdown.style.display = "none";
    }
    if (clearBtn) clearBtn.style.display = "none";
  }

  function fetchUsers(query) {
    const q = (query || "").trim();
    const { dropdown } = getElements();
    if (!dropdown) return;

    fetch(`/admin/users/search.json?q=${encodeURIComponent(q)}`, {
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(res => res.json())
      .then(data => {
        renderDropdown(data);
      })
      .catch(err => {
        console.error("Error fetching users:", err);
        renderDropdown([]);
      });
  }

  function handleInputChange(val) {
    const { hiddenInput, clearBtn } = getElements();
    if (hiddenInput) hiddenInput.value = "";
    if (clearBtn) clearBtn.style.display = val ? "inline-block" : "none";

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      fetchUsers(val);
    }, 150);
  }

  document.addEventListener("focusin", (e) => {
    if (e.target && e.target.id === "user_search_input") {
      fetchUsers(e.target.value);
    }
  });

  document.addEventListener("input", (e) => {
    if (e.target && e.target.id === "user_search_input") {
      handleInputChange(e.target.value);
    }
  });

  document.addEventListener("paste", (e) => {
    if (e.target && e.target.id === "user_search_input") {
      setTimeout(() => {
        handleInputChange(e.target.value);
      }, 50);
    }
  });

  document.addEventListener("click", (e) => {
    const { container, dropdown, input } = getElements();

    if (e.target && (e.target.id === "clear_user_btn" || e.target.closest("#clear_user_btn"))) {
      e.preventDefault();
      clearUser();
      return;
    }

    const item = e.target.closest(".user-option-item");
    if (item) {
      e.preventDefault();
      selectUser(item.dataset.id, item.dataset.text);
      return;
    }

    if (e.target && e.target.id === "user_search_input") {
      fetchUsers(e.target.value);
      return;
    }

    if (container && !container.contains(e.target) && dropdown) {
      dropdown.classList.remove("show");
      dropdown.style.display = "none";
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.target && e.target.id === "user_search_input") {
      const { dropdown } = getElements();
      if (!dropdown) return;

      const items = dropdown.querySelectorAll(".user-option-item");
      if (dropdown.classList.contains("show") && items.length > 0) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          activeIndex = Math.min(activeIndex + 1, items.length - 1);
          highlightItem(items);
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          activeIndex = Math.max(activeIndex - 1, 0);
          highlightItem(items);
        } else if (e.key === "Enter" && activeIndex >= 0) {
          e.preventDefault();
          items[activeIndex].click();
        } else if (e.key === "Escape") {
          dropdown.classList.remove("show");
          dropdown.style.display = "none";
        }
      }
    }
  });

  function highlightItem(items) {
    items.forEach((item, idx) => {
      if (idx === activeIndex) {
        item.classList.add("active");
        item.scrollIntoView({ block: "nearest" });
      } else {
        item.classList.remove("active");
      }
    });
  }

})();

